import { call, put } from 'redux-saga/effects';
import { api } from 'rp-auth';
import { setSessionStatus } from '../actions/auth';

const { getSessionStatus } = api;

export default function* () {
  try {
    const sessionStatus = yield call(getSessionStatus);
    yield put(setSessionStatus(true));
    return sessionStatus;
  } catch (error) {
    yield put(setSessionStatus(false));
    return null;
  }
}
